import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host, api_auth} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';

import moment from 'moment'
import 'moment/locale/es'  


// Shared components
import PortletContent from 'components/PortletContent';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { COLORS } from '../../../../../utils/colors';
import { withTranslation } from 'react-i18next';

moment.locale('es')


class ResponseTimeForNodeSimplified extends Component {

    constructor(props) {
        super(props);
        // Referencia al componente del gráfico (compatible desde React 16.3+)
        this.chartComponentRef = React.createRef();

        // Vincular el método a la clase
        this.toggleAllSeries = this.toggleAllSeries.bind(this);
        this.state = {
            currentObjectiveId: this.props.params.objective.objetivo_id,
            prevObjectiveId: this.props.params.objective.objetivo_id,
            currentStepId: this.props.params.step,
            loadObjectiveData: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptions: this._chartOptionsBase,
            externalData: null,
            dataError: false,
            isLoading: true,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            allVisible:true
        }
    }

    _chartOptionsBase = {
        chart: {
            type: 'spline',
            zoomType: 'x',
            ignoreHiddenSeries: false,
            marginRight: 30,
            resetZoomButton: {
                theme: {
                    fill: 'white',
                    stroke: 'silver',
                    r: 0,
                    states: {
                        hover: {
                            fill: '#41739D',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            },
            events: {
                render: function () {
                    const chartContainer = this.container;
                    const btn = chartContainer.querySelector('.custom-toggle-btn');
                    if (btn && !btn.dataset.hasListener) {
                        btn.dataset.hasListener = 'true';
                        btn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            // Almacenamos la referencia de la instancia en window/ref si es necesario
                        });
                    }
                }
            }
        },
        title: {
            text: "",
            style: {
                fontSize: '' 
             }
        },
        /*subtitle: {
            text: 'Hola'
        },*/
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: ''
            }
        },
        xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
                second: '%l:%M:%S%P',
                minute: '%l:%M%P',
                hour: '%H:%M',
                day: '<br/><b>%e/%b</b>',
                week: '%e. %b',
                month: '%b %y',
                year: '%Y'
            },
            /*title: {
                text: 'Periodo'
            },*/

        },
        yAxis: {
            min: 0,
            title: {
                text: 'Tiempo de Respuesta (s)'
            },
            plotLines: []
        },
        plotOptions: {
            series: {
                gapSize: 2,
                marker: {
                    symbol: 'circle',
                    width: 8,
                    height: 8,
                    enabled: false
                },

            }
        },
        legend: {
            enabled: true,
            useHTML: true,
            symbolWidth: 0,
            labelFormatter: function() {
                let symbol = '<div style="background:' + this.color + ';width:15px;height:3px;margin-top:5px"></div>'
                let name= '<button style="padding-left:4px;border-width:0px;background:white">'+this.name+'</button>'
                return '<div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;">' + symbol + ' ' + name + '</div>'
              }
        },
        credits: {
            enabled: false
        },
        navigator: {
            enabled: null      
        },
        tooltip: {
            enabled: false,
            xDateFormat: '%Y-%m-%d',
            pointFormat: 'Tiempo de respuesta: <b>{point.y:.2f} (s)</b>'
        },
        series: [

        ]
    }

    setHoverData = (e) => {
        const { x, y, series } = e.target
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['y'] = y
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.params.objective.objetivo_id !== prevState.prevObjectiveId) {
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.params.objective.objetivo_id,
                time: nextProps.params.period,
                step: null,
                lastEvent: [],
                dataError: false,
                hoverData: null,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period !== prevState.time) {
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.params.objective.objetivo_id,
                time: nextProps.params.period,
                step: prevState.step,
                lastEvent: [],
                dataError: false,
                hoverData: null,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.step !== prevState.step) {
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.params.objective.objetivo_id,
                time: prevState.time,
                step: nextProps.params.step,
                lastEvent: [],
                dataError: false,
                hoverData: null,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period === prevState.time && nextProps.params.statePeriod !== prevState.statePeriod) {
            return {
                prevObjectiveId: nextProps.params.objective.objetivo_id,
                time: prevState.time,
                step: prevState.step,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.params.objective.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh,          
            }

        }else if(nextProps.params.date !== prevState.date){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.params.objective.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                date: nextProps.params.date,          
            }

        }
        return null;
    }

    componentDidMount() {
        // Intenta Obtener datos desde la API
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.params.objective.objetivo_id !== this.props.params.objective.objetivo_id) ||
            (prevProps.params.step !== this.state.step) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }
    }


    getDataFromAPI = (objectiveId) => {
        this.setState({isLoading: true})
        const { objetivo_id } = this.props.params.objective
        const { period, step, statePeriod, objective } = this.props.params
        let sla_rendimiento_ok = parseInt(objective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(objective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(objective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(objective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoParcialPasoCustom/?objetivoId=${objetivo_id}&token=${token}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&horarioId=0&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&pasoId=${step}&t=${period}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                step,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });

        } else {
            fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoParcialPaso/?objetivoId=${objetivo_id}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&pasoId=${step}&t=${period}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                step,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        }
    }


    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        step,
        fecha_inicio,
        fecha_termino) => {

        let arrayChartData = []
        let lastEventDict = []
        let auxDate = null
        const colors = ['#2199e8', '#fed12d', '#ff7373', '#ccff00', '#b6fcd5',
            '#065535', '#ffc0cb', '#008080', '#00ffff', '#ffa500',
            '#800000', '#fff68f', '#bada55', '#8a2be2', '#3b5998'];
        let ValueNavigator = false
        /*if (period === 'w' || fecha_inicio !== null){
            ValueNavigator = true
        }*/
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        const self = this;
        const isAllVisible = this.state.allVisible;
        Object.keys(externalData.Objetivo.Paso).map((Objectivekey) => {
            Object.keys(externalData.Objetivo.Paso[Objectivekey].rendimientoDetalle).map((key) => {
                let chartDataSeries = {}
                let arrayData = []
                let rowLen = externalData.Objetivo.Paso[Objectivekey].rendimientoDetalle[key].estadoDetalle.length;
                externalData.Objetivo.Paso[Objectivekey].rendimientoDetalle[key].estadoDetalle.forEach((item, forEachKey) => {
                    var dict = {};
                    let date = new Date(item.inicio)
                    let year = date.getFullYear()
                    let month = date.getMonth()
                    let day = date.getDate()
                    let hours = date.getHours()
                    let minutes = date.getMinutes()
                    let seconds = date.getSeconds()
                    dict['x'] = Date.UTC(year, (month), day, hours, minutes, seconds)
                    dict['y'] = item.respuesta
                    arrayData.push(dict)
                    if (forEachKey == (rowLen - 1)) {
                        if (auxDate == null) {
                            lastEventDict['x'] = dict['x']
                            lastEventDict['y'] = dict['y']
                            lastEventDict['name'] = externalData.Objetivo.Paso[Objectivekey].rendimientoDetalle[key].nodo_nombre;
                            auxDate = lastEventDict['x']
                            lastEventDict['namePeriod'] = 'Rango: últimas 3 horas'
                        }
                        if (auxDate < dict['x']) {
                            lastEventDict['x'] = dict['x']
                            lastEventDict['y'] = dict['y']
                            lastEventDict['name'] = externalData.Objetivo.Paso[Objectivekey].rendimientoDetalle[key].nodo_nombre;
                            auxDate = lastEventDict['x']
                            if (period === 'h') {
                                lastEventDict['namePeriod'] = 'Rango: últimas 3 horas'
                            } else if (period === 'd') {
                                lastEventDict['namePeriod'] = 'Rango: último día'
                            } else if (period === 'w') {
                                lastEventDict['namePeriod'] = 'Rango: última semana'
                            } else if (period === 'c') {
                                lastEventDict['namePeriod'] = 'Rango: ' + fecha_inicio + ' a ' + fecha_termino
                            }
                        }
                    }
                });
                chartDataSeries['name'] = externalData.Objetivo.Paso[Objectivekey].rendimientoDetalle[key].nodo_nombre;
                chartDataSeries['color'] = colors[key]
                chartDataSeries['data'] = arrayData
                arrayChartData.push(chartDataSeries)
            })
        })
        let arrayChartDataMarked = []
        Object.keys(externalData.Objetivo.Peridos_Marcados).map((key) => {

            let chartDataSeries = {}
            let dateStart = new Date(externalData.Objetivo.Peridos_Marcados[key].fecha_inicio)
            let dateEnd = new Date(externalData.Objetivo.Peridos_Marcados[key].fecha_termino)
            const idTipoMarcado = externalData.Objetivo.Peridos_Marcados[key].id_tipo_marcado
            chartDataSeries['from'] = Date.UTC(dateStart.getFullYear(dateStart), dateStart.getMonth(dateStart), dateStart.getDate(dateStart), dateStart.getHours(dateStart), dateStart.getMinutes(dateStart), dateStart.getSeconds(dateStart))
            chartDataSeries['to'] = Date.UTC(dateEnd.getFullYear(dateEnd), dateEnd.getMonth(dateEnd), dateEnd.getDate(dateEnd), dateEnd.getHours(dateEnd), dateEnd.getMinutes(dateEnd), dateEnd.getSeconds(dateEnd))
            chartDataSeries['color'] = idTipoMarcado === 10 ? COLORS.MARCADO_ATENTUS : idTipoMarcado === 9 ? COLORS.EVENTO_CLIENTE : ''
            chartDataSeries['zIndex'] = 1
            if (idTipoMarcado !== 7) {
                arrayChartDataMarked.push(chartDataSeries)
            }
        })
        this.setState({
            chartOptions: {
                chart: {
                    events: {
                        render: function () {
                            // Busca el botón exclusivamente dentro del contenedor propio de ESTE gráfico
                            const chartContainer = this.container;
                            const btn = chartContainer.querySelector('.custom-toggle-btn');
                            if (btn) {
                                btn.onclick = (e) => {
                                    e.stopPropagation();
                                    self.toggleAllSeries();
                                };
                            }
                        }
                    }
                },
                xAxis: {
                    plotBands: arrayChartDataMarked
                },
                yAxis: {
                    plotLines: [{
                        value: sla_rendimiento_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_rendimiento_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },
                plotOptions: {
                    series: {
                        point: {
                            events: {
                                mouseOver: this.setHoverData.bind(this)
                            }
                        },
                        events: {
                            legendItemClick: () => {
                                setTimeout(() => {
                                    this.checkAllVisible();
                                }, 10);
                            }
                        },

                    }
                },
                legend: {
                    enabled: true,
                    useHTML: true,
                    title: {
                        text: this.getToggleButtonHtml(
                            this.state.allVisible ? t('text.hide-isp') : t('text.show-isp')
                        )
                    },
                    symbolWidth: 0,
                    labelFormatter: function () {
                        const isVisible = this.visible;
                        const opacity = isVisible ? '1' : '0.65';
                        const textColor = isVisible ? '#333333' : '#666666';
                        const lineThrough = isVisible ? 'none' : 'line-through';
                
                        let symbol = `<div style="background:${this.color};width:15px;height:3px;margin-top:5px;opacity:${opacity};"></div>`;
                        let name = `<button style="padding-left:4px;border-width:0px;background:transparent;color:${textColor};text-decoration:${lineThrough};opacity:${opacity};cursor:pointer;">${this.name}</button>`;
                
                        return `<div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;opacity:${opacity};">${symbol} ${name}</div>`;
                    },
                },
                navigator: {
                    enabled: ValueNavigator      
                },
                series: arrayChartData

            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            step: step,
            chartOptionsBase: {
                ...this._chartOptionsBase,
                xAxis: {
                    ...this._chartOptionsBase.xAxis,
                    plotBands: arrayChartDataMarked
                },
                yAxis: {
                    ...this._chartOptionsBase.yAxis,
                    plotLines: [{
                        value: sla_rendimiento_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_rendimiento_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },
                legend: {
                    ...this._chartOptionsBase.title,
                    title: {
                        text: externalData.Objetivo.Paso[0].paso_nombre
                    }
                },
                navigator: {
                    enabled: ValueNavigator      
                },
                series: arrayChartData
            }
        });
    }

    toggleAllSeries(forcedState) {
        const chart = this.chartComponentRef.current?.chart || this.chartComponentRef?.chart;
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (!chart) return;
    
        const nextState = typeof forcedState === 'boolean' ? forcedState : !this.state.allVisible;
    
        chart.series.forEach((series) => {
            if (nextState) {
                series.show(false);
            } else {
                series.hide(false);
            }
        });
    
        this.setState({ allVisible: nextState }, () => {
            // Actualizamos el título de la leyenda para refrescar el texto del botón
            const btnText = nextState ? t('text.hide-isp') : t('text.show-isp');
            chart.update({
                legend: {
                    title: {
                        text: this.getToggleButtonHtml(btnText)
                    }
                }
            });
        });
    }
    
    checkAllVisible() {
        const chart = this.chartComponentRef.current?.chart || this.chartComponentRef?.chart;
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (!chart) return;
    
        const isAnyVisible = chart.series.some(series => series.visible);
    
        if (this.state.allVisible !== isAnyVisible) {
            this.setState({ allVisible: isAnyVisible }, () => {
                const btnText = isAnyVisible ? t('text.hide-isp') : t('text.show-isp');
                chart.update({
                    legend: {
                        title: {
                            text: this.getToggleButtonHtml(btnText)
                        }
                    }
                });
            });
        }
    }
    
    // Método auxiliar para generar la estructura HTML del botón
    getToggleButtonHtml(btnText) {
        return `
            <div style="display: flex; justify-content: flex-end; margin-bottom: 8px;">
                <button 
                    class="custom-toggle-btn"
                    style="
                        background: #ffffff;
                        border: 1px solid #cccccc;
                        border-radius: 4px;
                        color: #333333;
                        font-size: 11px;
                        cursor: pointer;
                        padding: 4px 8px;
                    "
                >
                    ${btnText}
                </button>
            </div>
        `;
    }

    render() {
        const { dataError, chartOptions, isLoading,chartOptionsBase ,step,allVisible} = this.state;
        const { t } = this.props;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        if (!dataError) {
            sessionStorage.setItem("chartResponseTimeForNode"+String(step),JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} t={t} allVisible={allVisible} toggleAllSeries={this.toggleAllSeries} chartRef={this.chartComponentRef}/>)
        }
        else if (dataError) {
            return (<p>{t ? t('text.no-data') : 'No hay datos..'}</p>)
        }
        else return (<p>{t ? t('text.error') : 'Error!'}</p>)

    }
}

function FormattedChart(props) {
    const t = props.t
    return (
        <div >
            <div style={props.styleHidden}>
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            {t ? t('text.loading') : 'Cargando Información...'}
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            </div>
            <div style={props.style}>
                <HighchartsReact
                    ref={props.chartRef}
                    highcharts={Highcharts}
                    options={props.chartOptions} />
            </div>
        </div>
    )
}

export default withTranslation()(withRouter(ResponseTimeForNodeSimplified));